import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Divider from '@mui/material/Divider'
import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import InfoIcon from '@mui/icons-material/Info'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import ScheduleIcon from '@mui/icons-material/Schedule'
import LocationOnIcon from '@mui/icons-material/LocationOn'
// import BusSchedule from './BusSchedule'
import Button from '@mui/material/Button'
import { urlFromLocationName } from '../../_Components/addUrlToLocation.js'
import { useTranslation } from 'react-i18next'

export default function TravelAndParkingSpecific ({ travelAndParking, race }) {
  const { t } = useTranslation('raceGuide')
  const theme = useTheme()
  const { locations } = race || {}

  if (!travelAndParking || travelAndParking.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography
          variant='body1' sx={{
          color: 'text.secondary'
        }}
        >
          {t('travelParking.noInfo')}
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      {travelAndParking.map((item, index) => {
        const key = `travel-item-${index}`

        // Handle title + description sections
        if (item.title && item.description) {
          return (
            <Card key={key} sx={{ mb: 3, boxShadow: 3, borderRadius: 2 }}>
              <CardContent>
                <Typography
                  variant='h6'
                  component='h3'
                  sx={{
                    mb: 2,
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <DirectionsCarIcon />
                  {item.title}
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    lineHeight: 1.6,
                    color: 'text.primary',
                    pl: { xs: 0, sm: 4 },
                    whiteSpace: 'pre-line'
                  }}
                >
                  {urlFromLocationName(locations, item.description)}
                </Typography>
              </CardContent>
            </Card>
          )
        }

        // Handle info sections
        if (item.info || item.action) {
          return (
            <Box key={key} sx={{ mb: 3 }}>
              {item.info &&
                <Typography
                  variant='body1'
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mb: 1,
                    color: 'text.primary',
                    fontWeight: 'medium'
                  }}
                >
                  <InfoIcon color='info' />
                  {urlFromLocationName(locations, item.info)}
                </Typography>}
              {/* {item.actionUrl &&
                <Button variant='contained' onClick={() => window.open(item.actionUrl, '_blank')}>
                  {item.action}
                </Button>} */}
              {item.actionUrl &&
                <Box sx={{ mt: 2 }}>
                  <Button variant='contained' sx={{ mr: 2 }} onClick={() => window.open('https://www.peakssports.com/guides/goat_pre_race.pdf', '_blank')}>
                    {t('travelParking.preRaceBus')}
                  </Button>
                  <Button variant='contained' onClick={() => window.open('https://www.peakssports.com/guides/goat_post_race.pdf', '_blank')}>
                    {t('travelParking.postRaceBus')}
                  </Button>
                </Box>}
            </Box>
          )
        }

        // Handle BusSchedule component
        // if (item?.scheduleTitle) {
        //   return <BusSchedule key={key} {...{ distance }} />
        // }

        // Handle notes lists
        if (item.notes && Array.isArray(item.notes)) {
          return (
            <Card key={key} sx={{ mb: 3, backgroundColor: 'background.paper' }}>
              <CardContent>
                <Typography
                  variant='h6'
                  component='h4'
                  sx={{
                    mb: 2,
                    color: 'warning.main',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <InfoIcon color='warning' />
                  {t('travelParking.importantNotes')}
                </Typography>
                <List dense>
                  {item.notes.map((note, noteIndex) => (
                    <ListItem key={`note-${noteIndex}`} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <Box sx={{ width: 6, height: 6, bg: 'warning.main', borderRadius: '50%' }} />
                      </ListItemIcon>
                      <Typography
                        variant='body2' sx={{
                        color: 'text.secondary'
                      }}
                      >
                        {urlFromLocationName(locations, note)}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          )
        }

        // Handle timeTable
        if (item.timeTable) {
          const { date, shuttelTime, ceremonyTime, startTime, location } = item.timeTable
          return (
            <Card
              key={key} sx={{
              borderLeft: `4px solid ${theme.palette.primary.main}`
            }}
            >
              <CardContent>
                <Typography
                  variant='h5'
                  component='h3'
                  sx={{
                    mb: 2,
                    color: 'primary.contrastText',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  {t('travelParking.shuttleSchedule')}
                </Typography>

                <Box sx={{ display: 'grid', gap: 2, mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LocationOnIcon />
                    <Typography variant='body1' sx={{ fontWeight: 'medium' }}>
                      {urlFromLocationName(locations, location)}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ScheduleIcon />
                    <Typography variant='body1' sx={{ fontWeight: 'medium' }}>
                      {new Date(date).toLocaleDateString('en-US', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 2, borderColor: 'primary.main' }} />

                <Box sx={{ display: 'grid', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                      variant='body2' sx={{
                      color: 'text.secondary'
                    }}
                    >
                      {t('travelParking.shuttleDeparture')}
                    </Typography>
                    <Chip
                      label={`${shuttelTime}`}
                      size='small'
                      sx={{ color: 'primary.contrastText' }}
                    />
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                      variant='body2' sx={{
                      color: 'text.secondary'
                    }}
                    >
                      {t('travelParking.openingCeremony')}
                    </Typography>
                    <Chip
                      label={`${ceremonyTime}`}
                      size='small'
                      sx={{ color: 'primary.contrastText' }}
                    />
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                      variant='body2' sx={{
                      color: 'text.secondary'
                    }}
                    >
                      {t('travelParking.raceStart')}
                    </Typography>
                    <Chip
                      label={`${startTime}`}
                      size='small'
                      sx={{ color: 'primary.contrastText' }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          )
        }

        return null
      })}
    </Box>
  )
}
